import universal from 'react-universal-component'

export const UniversalPlayground= universal(props => import('./PlaygroundRoot'))

export default UniversalPlayground